import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import SogForm from "@/shared/ui/SogForm.vue";
import SogFormField from "@/shared/ui/SogFormField.vue";
import SogDropDownList from "@/shared/ui/SogDropDownList.vue";
import SogTextBox from "@/shared/ui/SogTextBox.vue";
import SogRadioButtonGroup from "@/shared/ui/SogRadioButtonGroup.vue";
import Person from "@/shared/model/person";
import {computed, reactive, ref, watch} from "vue";
import SogRadioButtonGroupItem from "@/shared/ui/types/SogRadioButtonGroupItem";
import SogFormValidationRule from "@/shared/ui/types/SogFormValidationRule";
import PersonAddressEditComponent from "@/modules/OrganisationStructure/components/PersonAddressEditComponent.vue";


interface Props {
  person: Person,
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars

export default /*@__PURE__*/_defineComponent({
  __name: 'PersonEditComponent',
  props: {
    person: { default: () => new Person() }
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;

const _lstPersonType = reactive([{id: "Natural", value: "Natürliche Person", icon: "person"}, {
  id: "Legal",
  value: "Juristische Person",
  icon: "business"
}]);
const _form = ref<InstanceType<typeof SogForm> | null>(null)
const _value = reactive({person: props.person})
const _fields = {text: 'value', value: 'id'}
const _sexItems: SogRadioButtonGroupItem[] = [{label: "Herr", value: "M"}, {label: "Frau", value: "W"}]

const _validations: SogFormValidationRule[] = [
  {name: 'Firma', rules: {required: [true, "Geben Sie einen Namen ein."]}},
  {name: 'Nachname', rules: {required: [true, "Geben Sie einen Namen ein."]}},
]

watch(props, () => {
    _value.person = props.person;
  }, {immediate: true}
)
const _legalName1 = computed(() => {
  return props.person.isBranch() ? "Name*" : "Firma*"
})

const _legalName2 = computed(() => {
  return props.person.isBranch() ? "Zusatz" : "Firmenzusatz"
})
const validate = (): boolean => {
  if (_form.value)
    return _form.value.validate();
  return false;
}

const getPerson = (): Person => {
  return _value.person;
}
__expose({
  validate, getPerson
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(SogForm, {
      ref_key: "_form",
      ref: _form,
      validations: _validations
    }, {
      default: _withCtx(() => [
        _withDirectives(_createVNode(SogFormField, null, {
          default: _withCtx(() => [
            _createVNode(SogDropDownList, {
              modelValue: _value.person.personType,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_value.person.personType) = $event)),
              placeholder: "Typ",
              "data-source": _lstPersonType,
              fields: _fields,
              width: "220px"
            }, null, 8, ["modelValue", "data-source"])
          ]),
          _: 1
        }, 512), [
          [_vShow, !_value.person.isEmployee()]
        ]),
        _withDirectives(_createElementVNode("div", null, [
          _createVNode(SogFormField, null, {
            default: _withCtx(() => [
              _createVNode(SogTextBox, {
                modelValue: _value.person.name1,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_value.person.name1) = $event)),
                placeholder: _legalName1.value,
                autocomplete: "true",
                name: "Firma",
                width: "220px"
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          }),
          _createVNode(SogFormField, null, {
            default: _withCtx(() => [
              _createVNode(SogTextBox, {
                modelValue: _value.person.name2,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_value.person.name2) = $event)),
                placeholder: _legalName2.value,
                autocomplete: "true",
                name: "Firmenzusatz",
                width: "220px"
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          })
        ], 512), [
          [_vShow, _value.person.personType==='Legal']
        ]),
        _withDirectives(_createElementVNode("div", null, [
          _createVNode(SogFormField, null, {
            default: _withCtx(() => [
              _createVNode(SogRadioButtonGroup, {
                modelValue: _value.person.sex,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_value.person.sex) = $event)),
                items: _sexItems,
                name: "Sex"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(SogFormField, null, {
            default: _withCtx(() => [
              _createVNode(SogTextBox, {
                modelValue: _value.person.name2,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_value.person.name2) = $event)),
                placeholder: "Vorname",
                autocomplete: "true",
                name: "Vorname",
                width: "220px"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(SogFormField, null, {
            default: _withCtx(() => [
              _createVNode(SogTextBox, {
                modelValue: _value.person.name1,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_value.person.name1) = $event)),
                placeholder: "Nachname*",
                autocomplete: "true",
                name: "Nachname",
                width: "220px"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ], 512), [
          [_vShow, _value.person.personType==='Natural']
        ])
      ]),
      _: 1
    }, 512)
  ]))
}
}

})